import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import VendorCard from '@/components/VendorCard'

export default function ADCreators() {
  // Fetch all AD-creator vendors
  const { data: adCreators, isLoading } = useQuery({
    queryKey: ['ad-creators'],
    queryFn: async () => {
      try {
        // Get vendors where vendor_type is 'ad-creator'
        const { data, error } = await supabase
          .from('vendors')
          .select(`
            id,
            user_id,
            vendor_name,
            vendor_description,
            vendor_email,
            vendor_phone,
            vendor_logo_url
          `)
          .eq('vendor_type', 'ad-creator')
          .order('vendor_name', { ascending: true })

        if (error) {
          console.warn('Error fetching AD creators:', error)
          return []
        }

        // Add user_id and vendor_type to each vendor for navigation
        return (data || []).map((vendor: any) => ({
          ...vendor,
          user_id: vendor.user_id,
          vendor_type: 'ad-creator',
        }))
      } catch (err) {
        console.warn('Error in AD creators query:', err)
        return []
      }
    },
    retry: false,
  })

  if (isLoading) {
    return (
      <div className="max-w-6xl mx-auto">
        <p style={{ color: 'var(--text-primary)' }}>Loading AD creators...</p>
      </div>
    )
  }

  return (
    <div className="max-w-6xl mx-auto">
      <h1 
        className="text-3xl font-bold mb-6"
        style={{ color: 'var(--text-primary)' }}
      >
        AD Creators
      </h1>

      {!adCreators || adCreators.length === 0 ? (
        <p style={{ color: 'var(--text-primary)' }}>
          No AD creators available.
        </p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {adCreators.map((creator) => (
            <VendorCard key={creator.id} vendor={creator} />
          ))}
        </div>
      )}
    </div>
  )
}

